import { Dispatch, SetStateAction, createContext } from "react";
import { IColorScheme } from "../../../types";

export interface IPatientContext {
      isBtnLoading: boolean | undefined;
      setIsBtnLoading: Dispatch<SetStateAction<boolean>>;
      handleNextTab: () => void;
      handleBackTab: () => void
      isFormUpdating: boolean | undefined;
      setIsFormUpdating: Dispatch<SetStateAction<boolean>>;
      isBtnDisable: boolean | undefined;
      isBtnNextClick: boolean;
      isBtnBackClick: boolean;
      setIsBtnDisable: Dispatch<SetStateAction<boolean>>;
      progress: number | undefined;
      setProgress: Dispatch<SetStateAction<number>>
      activeTab: string | undefined;
      setActiveTab: Dispatch<SetStateAction<string | undefined>>
      activeSubTab: number;
      setActiveSubTab: Dispatch<SetStateAction<number>>
      colorScheme: IColorScheme;
      setColorScheme: Dispatch<SetStateAction<IColorScheme>>;
};

export const PatientContext = createContext<IPatientContext>({
      isBtnLoading: false,
      setIsBtnLoading: () => { },
      handleNextTab: () => { },
      handleBackTab: () => { },
      isFormUpdating: false,
      setIsFormUpdating: () => { },
      isBtnDisable: true,
      isBtnBackClick: false,
      isBtnNextClick: false,
      setIsBtnDisable: () => { },
      progress: 0,
      setProgress: () => { },
      activeTab: "",
      setActiveTab: () => { },
      activeSubTab: 1,
      setActiveSubTab: () => { },
      colorScheme: {} as IColorScheme,
      setColorScheme: () => { },
});